import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { TextBoxField, FormGroup } from '@appbase/components/forms';
import { RoleGroup } from '@appbase/api/role';
import { ROLE_GROUP_MODAL } from '@appbase/components/modal/modal-names';
import webpartRegister, { RegisteredComponentInfo } from '@webparts/components/webparts/WebpartRegistration';
import { Dropdown } from '@gnb/components/Common';
import api from '@webparts/api';

/**
 * 문자열을 kebab-case로 변환합니다.
 * @param value 문자열
 */
const kebabCase = (value: string) =>
    value
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[\s_]+/g, "-")
        .toLowerCase();
/**
 * 웹파트 추가/편집 모달
 * 웹파트의 상세 설정을 수정할 수 있다.
 */
@Component({
    components: { Dropdown, TextBoxField, FormGroup },
})
export default class WebpartModalContent extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: String }) company!: string;
    @Prop({ type: Object, required: true }) value!: webpartv3.Webpart;
    /** 웹파트 생성을 위한 모달인지 편집을 위한 모달인지 여부 */
    @Prop({ type: String, default: "new" }) mode!: "edit" | "new";

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    dataMounted: boolean = false;
    availableComponents: RegisteredComponentInfo[] = [];
    type: string = "";
    boardList: Array<any> = [];
    woptions: any = {};
    tab: webpartBoard.BoardTab[] = [];
    displayCount: number = 5;
    shortcutList: webpartShortcut.Shortcut[] = [];

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    get roles(): string {
        const { roles } = this.value;
        if (roles) return roles?.map((x) => x.roleName).join(", ");
        else return "";
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H E S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    @Watch("value.component")
    onCnameChanged(v: string) {
        this.value.component = kebabCase(v);
        this.setProps();
    }

    // menuplanner 웹파트 타겟 변경 시 저장된 설정값 set
    @Watch("woptions.target")
    setTarget() {
        this.setPropsValue();
    }

    // 설정 옵션 변경 감지
    // 웹파트 옵션 설정값 JSON으로 변환
    @Watch("woptions")
    setPropsValue() {
        if (this.woptions && this.woptions.type) {
            // board 타입이면 tab 데이터 전체 포함
            if (this.type == "board") {
                this.woptions.prop = this.tab;
            }
            // else if (this.type == "shortcut") {
            //     this.woptions.prop = this.shortcutList;
            // }
            // woption 데이터 props 값으로 전달
            this.value.props = JSON.stringify(this.woptions);
        }
    }

    // board 타입 웹파트
    // 탭 사용 false 일 때 입력데이터 지움
    @Watch("woptions.useTab")
    useTab(val: boolean) {
        // 탭 2개 이상이고 탭사용 옵션 false 하는 경우
        // 탭 설정값 리셋
        if (!val && this.tab.length > 1) {
            this.tab = [{ title: "", boardId: -1, displayCount: this.displayCount, includeContent: false, showImage: false }];
        }
        // 게시판 웹파트 설정값 set (미리보기 변경)
        this.setPropsValue();
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    // 웹파트 저장된 설정값 set
    // board타입 default tab,woption data, menuplanner타입 default woption
    setProps() {
        const tar = this.availableComponents.filter((i) => i.name == this.value.component);
        if (tar.length > 0) {
            this.type = tar[0].type as string;
            this.woptions = {};
            if (this.type == "board") {
                this.tab = [{ title: "", boardId: -1, displayCount: this.displayCount, includeContent: false, showImage: false }];
                this.woptions = { type: this.type, useTab: false, prop: this.tab };
            } else if (this.type == "menuplanner") {
                this.woptions = { type: this.type, target: "SJ" };
            } else if (this.type == "banner") {
                this.woptions = { type: this.type, isGlobal: false };
            } else if (this.type == "singlebanner") {
                this.woptions = { type: this.type, targetBoard: -1 };
            }
            // else if (this.type == "shortcut") {
            //     this.woptions = { type: this.type, prop: this.shortcutList };
            // }
        }
    }

    // 웹파트 권한 설정
    handleChangeRoleGroups() {
        const modal: appbase.IModalOpenable = this.$refs["modal"] as any;
        const options: appbase.TModalInfo<any> = {
            component: ROLE_GROUP_MODAL,
            props: {
                initialRoles: this.value.roles,
                comCode: this.company,
            },
            events: {
                // 저장 버튼 클릭 이벤트 핸들러
                ok: async (roles: RoleGroup[]) => {
                    this.value.roles = roles;
                    console.log("ok", roles);
                    modal.closeModal();
                },
                // 취소 버튼 클릭 이벤트 핸들러
                cancel: () => {
                    console.log("cancel");
                    modal.closeModal();
                },
            },
        };
        modal.openModal(options);
    }

    // board 타입 웹파트 탭 추가/제거
    addTab() {
        this.tab.push({ title: "", boardId: -1, displayCount: this.displayCount, includeContent: false, showImage: false });
        this.setPropsValue();
    }
    deleteTab(val: number) {
        this.tab = this.tab.filter((i, idx) => idx != val);
        this.setPropsValue();
    }

    // 글로벌게시판 제외
    removeGlobalBoard() {
        return this.boardList.filter((b) => !b.isGlobal);
    }

    // 바로가기 타입 링크 추가/제거
    addLink() {
        this.shortcutList.push({
            title: "",
            titleEn: "",
            titleCh: "",
            titleJp: "",
            description: "",
            linkUrl: "",
            order: this.shortcutList.length + 1,
            isUse: true,
            roleAuthList: [],
        });
        this.setPropsValue();
    }

    deleteLink(val: number) {
        this.shortcutList = this.shortcutList.filter((i, idx) => idx != val);
        this.setPropsValue();
    }

    // 바로가기 링크별 권한 설정
    handleChangeLinkRoleGroups(shortcutInfo: webpartShortcut.Shortcut) {
        const modal: appbase.IModalOpenable = this.$refs["modal"] as any;
        const options: appbase.TModalInfo<any> = {
            component: ROLE_GROUP_MODAL,
            props: {
                initialRoles: shortcutInfo.roleAuthList,
                comCode: this.company,
            },
            events: {
                // 저장 버튼 클릭 이벤트 핸들러
                ok: async (roles: RoleGroup[]) => {
                    shortcutInfo.roleAuthList = roles;
                    this.setPropsValue();
                    console.log("ok", roles);
                    modal.closeModal();
                },
                // 취소 버튼 클릭 이벤트 핸들러
                cancel: () => {
                    console.log("cancel");
                    modal.closeModal();
                },
            },
        };
        modal.openModal(options);
    }

    getShortcutRoleNameList(shortcutInfo: webpartShortcut.Shortcut) {
        if (shortcutInfo.roleAuthList) return shortcutInfo.roleAuthList?.map((x) => x.roleName).join(", ");
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    created() {
        this.availableComponents = webpartRegister.components();
        let mountPromise: Promise<void>[] = [
            api.board.GetBoardList(this.company).then((res: any) => {
                this.boardList = res;
            }),
        ];

        // 바로가기 목록 set
        if (this.value.id) {
            mountPromise.push(
                api.shortcut.getShortcutInfoList(this.value.id).then((res: any) => {
                    this.shortcutList = res;
                })
            );
        }

        Promise.all(mountPromise).finally(() => {
            if (this.value.props) {
                this.woptions = JSON.parse(this.value.props as string);
                this.type = this.woptions.type;
                if (this.type == "board") this.tab = this.woptions.prop;
            } else this.setProps();

            this.dataMounted = true;
        });
    }
}
